import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { SHJC_URL, postAsync } from '../../components/helper/axiosHelper';
import OTPInput from './OTPInput';

const OTPVerifyModal = ({ otpModal, setOtpModal, prevData, isEmail, userId, setUpdatedData, updatedData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState('');
  const [guidLink, setGuidLink] = useState('');
  const [OTPVerify, setOTPVerify] = useState(false);
  const [timer, setTimer] = useState(300);
  const [isResending, setIsResending] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const token = localStorage.getItem('token');
  const { t } = useTranslation();
  let axiosConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    if (timer > 0 && otpModal) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);

      return () => clearInterval(interval);
    } else {
      if (timer === 0) {
        setIsDisabled(true);
      }
    }
  }, [timer, otpModal]);

  useEffect(() => {
    localStorage.setItem('otpTimer', timer);
  }, [timer]);

  useEffect(() => {
    const savedTimer = parseInt(localStorage.getItem('otpTimer'), 10);
    if (savedTimer > 0) {
      setTimer(savedTimer);
    }
  }, []);

  const handleResendOTP = async () => {
    setIsLoading(true);
    setIsResending(true);
    setTimer(300);
    setIsDisabled(false);
    setIsLoading(false);
    setIsResending(false);

    if (isEmail) {
      const body = {
        otp: 0,
        isEmail: true,
        email: updatedData.email,
        mobile: '',
      };

      await postAsync('EP_UserAuthentication/OTPgenerator/', body, axiosConfig)
        .then((response) => {
          setOtpModal(true);
        })
        .catch((error) => {
          toast.error(`${t(error.response.data.message)}`);
        });
    } else {
      const body = {
        otp: 0,
        isEmail: isEmail,
        email: '',
        mobile: updatedData.mobile,
        EPUserID: userId,

      };

      await postAsync('EP_UserAuthentication/OTPgenerator/', body, axiosConfig)
        .then((response) => {})
        .catch((error) => {
          toast.error(`${t(error.response.data.message)}`);
        });
    }
  };

  const handleSubmit = async (OTPNumber) => {
    setIsLoading(true);
    const body = {
      otp: +OTPNumber,
      isEmail,
      email: isEmail ? updatedData.email : '',
      mobile: isEmail ? '' : updatedData.mobile,
      EPUserID: userId,
    };

    await postAsync('EP_UserAuthentication/ConfirmUpdateOTP', body, axiosConfig)
      .then((response) => {
        const link = `${SHJC_URL}/verify/user/${response.data[0]}/${isEmail ? updatedData.email : updatedData.mobile}/${isEmail}`;
        const links = `${SHJC_URL}/verify/user/${response.data[0]}/${isEmail ? updatedData.email : updatedData.mobile}/${isEmail}`;
        console.log(link, 'ActivationLink');
        console.log(links, 'DEVS_ActivationLink');
        console.log(response?.message,"response?.messageresponse?.message")
        toast.success(`${t(response?.message)}`);
        setOTPVerify(true);
        setIsLoading(false);

        setTimeout(() => {
          setOtpModal(false);
          setOTPVerify(false);
        }, 3000);
      })
      .catch((error) => {

        setIsLoading(false);
        toast.error(t(`${error.response.data.message}`));
      });
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const handleModal = () => {
    setTimer(300);
    setOtpModal(false);
  };

  return (
    <>
      {otpModal ? (
        <>
          <div className="modal-overlay justify-star items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto mx-auto max-w-3xl">
              <div className="relative font-inter antialiased">
                <main className="relative min-h-screen flex flex-col justify-center overflow-hidden">
                  <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-24">
                    <div className="flex justify-center">
                      <div className="max-w-md mx-auto text-center bg-white text-black px-4 sm:px-8 py-10 rounded-xl shadow">
                        {!isLoading ? (
                          !OTPVerify ? (
                            <>
                              <p onClick={handleModal} className="text-right cursor-pointer">
                                x
                              </p>
                              <header className="pb-3">
                                <h1 className="text-2xl font-bold mb-1">{t('OTP Verification')}</h1>
                                <p className="text-[15px] text-slate-500">{`${t('Enter the 4-digit verification code that was sent to your')} ${isEmail ? t('Email') : t('Phone Number')}`}</p>
                              </header>

                              <OTPInput length={4} onComplete={handleSubmit} disabled={isDisabled} />

                              <div className="w-full sm:max-w-[260px] mx-auto mt-4">
                                <button
                                  type="submit"
                                  className={`w-full inline-flex justify-center whitespace-nowrap rounded-full bg-customgreen px-3.5 py-2.5 text-sm font-medium text-white shadow-sm shadow-indigo-950/10 hover:bg-hovergreen focus:outline-none focus:ring-2 focus:ring-customgreen focus-visible:outline-none focus-visible:ring  transition-colors duration-150 ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                                  disabled={isDisabled}
                                >
                                  {t('Verify')}
                                </button>
                              </div>

                              <div className="text-sm flex justify-center items-center text-slate-500 mt-4 mr-5">
                                <p>{t("Didn't receive code?")} </p>
                                <span
                                  className={`font-medium ${timer === 0 ? 'text-customgreen cursor-pointer hover:text-customgreen' : 'text-slate-500'}`}
                                  onClick={timer === 0 ? handleResendOTP : null}
                                >
                                  {t('Resend')} {timer > 0 && `(${formatTime(timer)})`}
                                </span>
                              </div>
                            </>
                          ) : (
                            <>
                              <header className="mb-8">
                                <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                  {' '}
                                  <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />{' '}
                                  <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                                </svg>
                                <h1 className="text-2xl font-bold mb-1">{t('OTP Verified')}</h1>
                                  <p className="text-[15px] text-slate-500">{ `${t(`Your ${isEmail ? t('Email') : t('Phone Number')} is updated successfully`)} ` }</p>
                              </header>
                            </>
                          )
                        ) : (
                          <Loader />
                        )}
                      </div>
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default OTPVerifyModal;
